import { Component, Input, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/core/services/loading.service';
import { LoadingType } from 'src/app/core/types/types';
import { IonButton, IonLoading} from '@ionic/angular/standalone';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-overlay-loading',
  templateUrl: './overlay-loading.component.html',
  styleUrls: ['./overlay-loading.component.scss'],
  standalone : true,
  imports: [IonButton,IonLoading,CommonModule]
})
export class OverlayLoadingComponent implements OnInit {
  loadingType: LoadingType = LoadingType.LINES;
  loadingMessage: string = 'Loading...';

  constructor(private loadingService: LoadingService) { }

  ngOnInit(): void {
    this.loadingService.loadingContent.subscribe((data: any) => {
      this.loadingMessage = data.message;
      this.loadingType = data.spinner;
    })
  }

  ngOnDestroy(): void {
    if(this.loadingService.loadingContent)this.loadingService.loadingContent.unsubscribe();
  }

}
